export class Tracking{
    init () {

        $("a.btn-poznaj_zalety").click(function () {
            let event_label = $(this).text();
            ga('send', 'event', 'CTA', 'click', event_label)
        });

    }
}